export const server_url = 'https://signal500.com/api/';
export const APP_VERSION = '1.0.2';
export const $STORAGE_USER_EMAIL = 'STORAGE_FORUMS_USER_EMAIL';
export const $STORAGE_USER_PASS = 'STORAGE_FORUMS_USER_PASS';
export const key = '1234567';
